"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var titleId = _ref.titleId,
      title = _ref.title,
      href = _ref.href,
      ariaLabel = _ref.ariaLabel;
  return "<h3 title=\"".concat(title, "\" class=\"title-name\" data-media-id=\"").concat(titleId, "\" tabindex=\"-1\">\n    <a tabindex=\"0\" href=\"").concat(href, "\" role=\"link\" aria-label=\"").concat(ariaLabel, "\">\n        ").concat(title, "\n    </a>\n</h3>");
};

exports["default"] = _default;